import { v4 as uuidv4 } from "uuid";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@/react/components/shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@/react/components/shared/BuilderUI/utils/buttonStyleHelpers";
import { getFontWeightOptions } from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import { defaultData as defaultP2Data } from "@/react/components/shared/Emails/VisualEmailBuilder/Blocks/Content/PBlock/P2BlockDefaultData";
import type {
  BaseBlock,
  BaseProp,
} from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  createH3Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { defaultData as defaultH3Data } from "@circle-react-shared/Emails/VisualEmailBuilder/Blocks/Headings/H3Block/H3BlockDefaultData";
import { defaultData as defaultProductCardData } from "../ProductCard/ProductCardDefaultData";
import { defaultStyles } from "./defaultStyles";

const headerContentTemplate: BaseProp = {
  prop: "children",
  type: "children",
  value: [
    createPBlock({
      text: "Tagline",
      baseData: defaultP2Data,
      styles: {
        fontWeight: getFontWeightOptions("600"),
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "0",
            marginBottom: "12",
            marginLeft: "0",
            marginRight: "0",
          },
        }),
      },
    }),
    createH3Block({
      text: "Heading",
      baseData: defaultH3Data,
      styles: {
        fontWeight: getFontWeightOptions("700"),
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "0",
            marginBottom: "20",
            marginLeft: "0",
            marginRight: "0",
          },
        }),
      },
    }),
    createPBlock({
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      baseData: defaultP2Data,
      styles: {
        margin: getMarginOptions({
          defaultValue: {
            marginTop: "0",
            marginBottom: "0",
            marginLeft: "0",
            marginRight: "0",
          },
        }),
      },
    }),
  ],
};

const createProductCardBlock = () => ({
  id: uuidv4(),
  type: "ProductCard",
  props: defaultProductCardData.props,
});

const productCardTemplate: BaseProp = {
  prop: "children",
  type: "children",
  value: [createProductCardBlock()],
};

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "ProductShot1",
  props: {
    headerContent: headerContentTemplate,
    productCard1: productCardTemplate,
    productCard2: productCardTemplate,
    productCard3: productCardTemplate,
    productCard4: productCardTemplate,
    productCard5: productCardTemplate,
    productCard6: productCardTemplate,

    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: defaultStyles.backgroundColor,
        }),
        padding: getPaddingOptions({
          defaultValue: defaultStyles.padding,
        }),
        margin: getMarginOptions({
          defaultValue: defaultStyles.margin,
        }),
      },
    },
  },
};
